module.exports = __webpack_public_path__ + "img/share-save-hover.95e63736.svg";